/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";
//import { useService } from "@web/core/utils/hooks";

export class WPCPortalStudentPlacementList extends Component {
    static template = 'wpc_portal.student_placement_list'
    static components = {

    }
    static defaultProps = {

    }
    setup() {
        var self = this;
        var state = useState({
            loading: true,
        })
        self.state = state;

        useEffect(()=>{
            self.get_placement_list();
        }, ()=>[])

        useEffect(()=>{
            self.get_placement_list();
        }, ()=>[])
    }

    get_placement_list(){
        var self = this;
        self.state.loading = true;
        return $.getJSON({url: '/api/student/placement_list'}).then(data=>{
            self.props.state.placement_list = data;
            self.state.loading = false;
        });
    }
}
